import { render } from "./TittleBetween.vue?vue&type=template&id=4bdf507a"
import script from "./TittleBetween.vue?vue&type=script&lang=js"
export * from "./TittleBetween.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__